import types from './types'

export default {
  [types.AUTHORIZATION_DETAIL_FORM](state, payload) {
    state.authorizationDetailForm = payload
  },
  [types.AUTHORIZATIONS_WITHOUT_CLAIMS_SUCCESS]: (state, payload) => {
    state.authorizationWithoutClaim = payload.content
    state.links = payload.links
    state.page = payload.page
  },
  [types.SET_FILTERS_CONFIGURATION]: (state, payload) => {
    state.filtersConfiguration = payload
  },
  [types.AUTHORIZATION_DETAIL]: (state, payload) => {
    state.authorizationDetail = payload
  },
  [types.RESET_AUTHORIZATION_STATE]: (state) => {
    state.authorizationDetailForm = null
    state.authorizationWithoutClaim = null
    state.filtersConfiguration = []
    state.authorizationDetail = null
    state.authorizationLoading = false
    state.authorizationForms = []
    state.authorizationFormsAndSteps = null
    state.currentForm = null
    state.currentStep = 0
    state.error = {}
    state.stepError = true
    state.inputs = [],
    state.authorizationSponsorStaticDocuments = null,
    state.authorizationSponsorStaticDocumentsError = null,
    state.authorizationPreInvoice= [],
    state.newAuthorizationStatus= null,
    state.authorizationInvoice= []
  },
  [types.SET_CURRENT_FORM] (state, payload) {
    state.currentForm = payload
  },
  [types.AUTHORIZATION_FORM_LOAD_SUCCESS] (state, payload) {
    state.authorizationForms = payload.response
    state.authorizationFormsAndSteps = payload.formsByStep
  },
  [types.AUTHORIZATION_LOADING] (state, payload) {
    state.authorizationLoading = payload
  },
  [types.AUTHORIZATION_LOAD_ERROR] (state) {
    state.errorAlert = true
  },
  [types.SET_CURRENT_STEP] (state, payload) {
    state.currentStep = payload
  },
  [types.SET_STEP_ERROR] (state, payload) {
    state.stepError = payload
  },
  [types.SET_INPUTS](state, payload) {
    const { slug, value } = payload;
    const inputs = state.inputs;
    const index = inputs.findIndex(input => input.slug === slug);

    if (index >= 0) {
      inputs[index].value = value;
    } else {
      inputs.push({ slug, value });
    }

    state.inputs = inputs
  },
  [types.SET_ERROR] (state, payload) {
    state.error = payload
  },
  [types.SET_CREATE_AUTHORIZATION_ACTION](state, payload) {
    state.createAuthorizationAction = payload
  },
  [types.SET_ACCOUNTS_SEARCH_VALUE]: (state, payload) => {
    state.accountsSearchValue = payload
  },
  [types.SET_ACCOUNT_INFO]: (state, payload) => {
    state.authorizationRcmAccountInfo = payload
  },
  [types.SET_AUTHORIZATION_SPONSOR_STATIC_DOCUMENTS]: (state, payload) => {
    if (payload.length > 0) {
      state.authorizationSponsorStaticDocuments = payload
    }
  },
  [types.SET_AUTHORIZATION_SPONSOR_STATIC_DOCUMENTS_ERROR]: (state, payload) => {
    state.authorizationSponsorStaticDocumentsError = payload
  },

  [types.SET_AUTHORIZATION_PRE_INVOICE]: (state, payload) => {
    state.authorizationPreInvoice = payload
  },

  [types.CLEAR_AUTHORIZATION_PRE_INVOICE]: (state) => {
    state.authorizationPreInvoice = []
  },

  [types.SET_NEW_AUTHORIZATION_STATUS]: (state, payload) => {
    state.newAuthorizationStatus = payload
  },

  [types.SET_AUTHORIZATION_INVOICE]: (state, payload) => {
    state.authorizationInvoice.push(payload)
  },

  [types.CLEAR_AUTHORIZATION_INVOICE]: (state) => {
    state.authorizationInvoice = []
  },

  [types.DELETE_AUTHORIZATION_INVOICE]: (state, payload) => {
    const newArray = state.authorizationInvoice.filter(item => item.slug !== payload);
    state.authorizationInvoice = [...newArray]
  },

  
}
